import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IMatchSubtitleV1Params } from './match-subtitle-v1-request';

export async function matchSubtitleV1Api({
  subtitleId,
  force,
}: IMatchSubtitleV1Params): Promise<Response> {
  const query = force ? '?force=true' : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/match/v1${query}`,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
